import {
  useQuery,
  type UseQueryOptions,
  type UseQueryResult,
  type QueryKey,
} from '@tanstack/react-query';
import service from '../service';
import type { InboxManagementRow } from '../types/inbox';

type InboxManagementResponse = InboxManagementRow[];
type DefaultError = unknown;

export function useInboxManagement<
  TData = InboxManagementResponse,
  TError = DefaultError,
>(
  options?: Omit<
    UseQueryOptions<InboxManagementResponse, TError, TData, QueryKey>,
    'queryKey' | 'queryFn'
  >,
): UseQueryResult<TData, TError> {
  return useQuery<InboxManagementResponse, TError, TData>({
    queryKey: ['inbox-management'],
    queryFn: async () => service.getInboxManagement(),
    ...options,
  });
}
